// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
      appUrl: 'https://painelapi.alfaebetosolucoes.org.br/',
      //appUrl: 'https://localhost:44370/',
      //appUrl: 'https://localhost:5005/',
      exportCsvUrl: 'https://frequencia.alfaebeto.org.br/geraplanilha/',
      //exportCsvUrl: 'https://localhost:44391/geraplanilha/', // IIS Express local; via dotnet run use http://localhost:5001/geraplanilha/
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
